import Box from 'components/shared/Box'
import Section from 'components/shared/Section'
import Text from 'components/shared/Text'
import { FormattedMessage } from 'react-intl'
import { SpaReservation } from 'store/selfcare-slice/types'
import SpaTicket from './tickets/SpaTicket'

interface ManageSpaProps {
    tickets: SpaReservation[]
}

const ManageSpa = ({ tickets }: ManageSpaProps) => (
    <Section id="manage-spa" hasSmallerSpacingsX hasSmallerSpacingsY>
        <Text variant="heading3" color="grayscale_900" mb={[24, 32]}>
            <FormattedMessage
                id="selfcare.spa.section_caption"
                defaultMessage="Wellness & SPA"
            />
        </Text>
        <Box gap={[16, 24]} isFullWidth>
            {tickets.map((ticket, index) => (
                <SpaTicket
                    spa={ticket}
                    key={ticket.original.detail.orderSpaTreatmentId}
                    index={index}
                />
            ))}
        </Box>
    </Section>
)

export default ManageSpa
